// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"702":"story","715":"list"}[chunkId] || chunkId) + "-" + {"583":"bdb48788517c4ffab4c9","702":"92849a961694e975d245","715":"6934ca798093ca43cb67"}[chunkId] + ".css";
};